import { render, staticRenderFns } from "./BpCurrentRatioDisplayer.vue?vue&type=template&id=63d465e3"
import script from "./BpCurrentRatioDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpCurrentRatioDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports